import { createContext, useContext } from 'react';

const noop = () => {};

export const LayoutChromeContext = createContext({ chromeHidden: false, setChromeHidden: noop });

export const useLayoutChrome = () => useContext(LayoutChromeContext);
